import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";
import ShipmentChargesTable from "../../components/ShipmentCharges/ShipmentChargesTable";
import ShipmentDurationTable from "../../components/ShipmentDuration/ShipmentDurationTable";
import ShipmentCalculatorTable from "../../components/ShipmentCalculator/ShipmentCalculatorTable";
import ShippingCalTableV2 from "../../components/ShipmentCalculator/ShippingCalTableV2";



const ShipmentCalculatorPage = () => {
    return (
        <>
            {/* MasterLayout */}
            <MasterLayout>

                <Breadcrumb title="Shipment Calculator" />
                {/* <ShipmentCalculatorTable/> */}

                <ShippingCalTableV2/>




            </MasterLayout>
        </>
    );
};

export default ShipmentCalculatorPage;
